<div *ngIf="listingId && unavailableDays && !isOwnListing"
    (touchstart)="hideErrorPrompt()"
    class="_flex _flex-col _items-center _justify-between _gap-8 _w-full"
    [formGroup]="formGroup">

    <div class="form-container _w-full">
        <app-datepicker
            id="listing-travel-dates"
            [inline]="true"
            [travelDates]="travelDates"
            [unavailableDays]="unavailableDays"
            [activeWindow]="activeWindow"
            [minimumNights]="minimumNights"
            (newDateSearch)="newSearchDates($event)"
            (isValid)="datesAreValid($event)"
            (checkinMonthChanged)="monthSelected($event)"
            (checkoutMonthChanged)="monthSelected($event)">
        </app-datepicker>

        <ng-content select="[slot=guests-and-fees]"></ng-content>

        <div *ngIf="userRemediableErrors?.length"
            class="_flex _items-center _justify-center _text-error-red _text-sm _text-center _my-4">
            <i class="fa-light fa-circle-exclamation _text-error-red _mr-1"></i>
            <div *ngFor="let error of userRemediableErrors">
                <span>{{ error }}</span>
            </div>
        </div>

        <div *ngIf="!travelDates.checkin || !travelDates.checkout" class="_flex _flex-col _items-center _text-sm _pt-3">
            <span>Add guests and dates to view booking rates.</span>
            <span *ngIf="commission && !consumerView">Then adjust your commission.</span>
        </div>
    </div>

    <div *ngIf="loadingPrices" class="_text-xl _h-12 _flex _flex-col _items-center _center-xy my-5">
        <i class="fas fa-circle-notch fa-spin _z-20"></i>
        <span class="_ml-1 _mt-2 _text-sm">Loading</span>
    </div>

    <div *ngIf="fees?.bookingFee?.amountMicros > 0 && !loadingPrices" class="_w-full _text-center _text-lg _min-h-11">

        <ng-container *ngIf="(!travelDates.checkin || !travelDates.checkout) || !commission">
            <span class="_text-lg">
                Best available rate
                <span class="_font-bold"><app-booking-price [fees]="fees"></app-booking-price></span>
                <span *ngIf="!travelDates.checkin || !travelDates.checkout">per night</span>
            </span>

            <ng-container *ngIf="commission && !consumerView">
                <app-reseller-commission-calculation
                    [caption]="'Your commission'"
                    [showAmount]="true"
                    [showPercentage]="true"
                    [exactFee]="fees"
                    [commission]="commission">
                </app-reseller-commission-calculation>
            </ng-container>
        </ng-container>

        <div *ngIf="travelDates.checkin && travelDates.checkout && consumerView && commission">
          <span class="_text-lg">
              Best available rate
              <span class="_font-bold">{{ formattedPrice }}</span>
          </span>
        </div>

        <div *ngIf="sliderOptions && travelDates.checkin && travelDates.checkout && commission && !consumerView"
            [ngClass]="{'_opacity-50 _cursor-not-allowed _pointer-events-none': !formGroup.valid || !travelDatesAreValid || showUserRemediableErrors}">
            <div id="priceSlider"
                class="adjustable-fees-slider _w-full _px-5 _pt-6 _pb-10 _bg-primary-1-tint-4 _rounded-md">
                <ngx-slider
                    [(value)]="price"
                    [options]="sliderOptions"
                    (valueChange)="adjustFees()"
                    (userChange)="userChange($event)">  
                </ngx-slider>
            </div>
            <div class="_flex _flex-col _gap-2 _mt-4">
                <div class="_flex _justify-between _items-center _text-md">
                    <div class="_w-1/3 _text-left">Client pays</div>
                    <div class="_w-1/3 _relative">
                        <span
                            class="_absolute _top-nudge-1 _right-0 _block _px-2 sm:_text-sm md:_text-md _py-1 _pointer-events-none"
                            [ngClass]="{'_opacity-0' : useManualPriceAdjustmentInput}">
                            {{ formattedPrice }}
                        </span>
                        <input type="number"
                            class="_input-reset _w-full _rounded _border _border-primary-1-tint-20 _text-right _text-md _px-2 _py-1"
                            [ngClass]="{
                                '_text-red-700' : useManualPriceAdjustmentInput && !adjustedPriceValid,
                                '_text-transparent' : !useManualPriceAdjustmentInput
                            }"
                            (input)="manualPriceUpdate($event.target)"
                            (focus)="manualAdjustmentActiveState(true, $event.target)"
                            (blur)="manualAdjustmentActiveState(false, $event.target)"
                            [value]="editablePrice">
                    </div>
                    <div *ngIf="(nightlyPrice$ | async) as nightlyPrice"
                         class="_w-1/3 _text-right _text-sm _text-primary-1-tint-50">
                        {{ (nightlyPrice.amountMicros) | currency: nightlyPrice.currency : 'symbol-narrow' : '1.0-0' }}
                        night
                    </div>
                </div>
                <div class="_flex _justify-between _items-center _text-md">
                    <div class="_flex-1 _text-left">
                        You earn
                        <span class="_pill-thin _font-bold _inline-block sm:_text-sm md:_text-md">
                                {{ adjustedCommissionRate }} %
                            </span>
                    </div>
                    <div *ngIf="(totalCommissionRate$ | async) as totalCommission"
                         class="_w-auto _text-right _px-2 _py-1">
                        {{ (totalCommission.amountMicros / 1000000) | currency: totalCommission.currency : 'symbol-narrow' : '1.0-0' }}
                    </div>
                    <div *ngIf="(nightlyCommissionRate$ | async) as nightlyCommissionRate"
                         class="_w-1/3 _text-right _text-sm _text-primary-1-tint-50">
                        {{ (nightlyCommissionRate.amountMicros / 1000000) | currency: nightlyCommissionRate.currency : 'symbol-narrow' : '1.0-0' }}
                        night
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="_w-full _relative">

        <ng-content select="[slot=client-reference]"></ng-content>

        <div class="sm-max:_fixed _bottom-0 _left-0 sm-max:_p-3 _w-full _z-10 _bg-white sm-max:_border-t sm-max:_border-transparency-black-25 sm-max:_shadow-top">
            <div class="_relative _w-full _h-full">
                <div class="_text-center sm-max:_max-w-600px _mx-auto">

                    <div class="_mb-4">
                        <ng-content select="[slot=add-to-proposal]"></ng-content>
                    </div>

                    <div *ngIf="showErrorPrompt"
                        class="_my-4 _w-full _p-2 _text-center _text-md _text-yellow-600 _bg-white _border _rounded-sm _border-yellow-600">
                        <span class="_text-left">
                            <div class="_flex _items-center _mb-1">
                                <i class="fa-light fa-circle-exclamation _text-yellow-600 _mr-1"></i>
                                <div>To proceed please ensure you have:</div>    
                            </div>
                            <ul class="_list-disc _pl-4">
                                <li *ngIf="!formGroup.valid || !travelDatesAreValid" class="_text-sm _text-black">Selected valid travel dates </li>
                                <li *ngIf="maxGuestsExceeded" class="_text-sm _text-black">Not exceeded max occupancy </li>
                                <li *ngIf="!businessCustomerReference" class="_text-sm _text-black">Entered a booking name</li>
                                <li *ngIf="showUserRemediableErrors" class="_text-sm _text-black">Corrected any panel error messages</li>  
                            </ul>
                        </span>
                    </div>

                    <app-button 
                        type="primary-green"
                        modifierClassNames="_w-full"
                        [onClick]="save.bind(this)">
                            {{ allowInstantBook ? 'Reserve' : 'Inquire' }}
                    </app-button>
                    <span class="_text-sm" *ngIf="allowInstantBook">A hold will be placed on your card</span>
                    <span class="_text-sm" *ngIf="!allowInstantBook">No payment required at this time</span>
                </div>
            </div>
        </div>
    </div>
</div>
